import { connect } from 'react-redux'
import { actions } from '@opallabs/wormhole'
import SlideSelector from '.'

const ConnectedSlideSelectorComponent = (props) => <SlideSelector {...props} />
const mapStateToProps = (state, props) => ({
  ...props,
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  createSlide: (params) => {
    const createSlideParams = {
      ...params,
      createSlideBackboneCallback: ownProps.createSlideBackboneCallback,
    }
    dispatch(actions.createSlide(createSlideParams))
  },
})
const ConnectedSlideSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedSlideSelectorComponent)
export default ConnectedSlideSelector
